import { createSelector } from 'reselect';
import { ticketsByEventIdSelector, ticketsByIdSelector } from './index';
export const eventIdFromPropSelector = (_state, props) => {
    return props.eventId;
};
export const makeTicketsOrderedByPositionSelector = () => createSelector(eventIdFromPropSelector, ticketsByEventIdSelector, ticketsByIdSelector, (eventId, ticketsByEventId, ticketsById) => {
    return ticketsByEventId[eventId]
        .map((ticketId) => ticketsById[ticketId])
        .sort((a, b) => {
        if (typeof a.position !== 'undefined' &&
            typeof b.position !== 'undefined' &&
            a.position < b.position) {
            return -1;
        }
        if (typeof a.position !== 'undefined' &&
            typeof b.position !== 'undefined' &&
            a.position < b.position) {
            return 1;
        }
        return 0;
    });
});
